import * as React from 'react';
import { Link } from 'react-router-dom';
import './Misc.css';

const Misc = () => {
    return (
        <div>
            <ul className='misc-menu'>
                <li><Link to='/misc/tgv'>TLX Group Verdict</Link></li>
                <li><Link to='/misc/mbl'>Main Batu Lagi</Link></li>
            </ul>
        </div>
    );
}

export default Misc;